/**
 * Site-wide configuration and constants
 * This file contains all site configuration including SEO, social media, and other site-wide settings.
 */

// Base site configuration
export const siteConfig = {
  // Site identity
  title: 'QRaft Code',
  description: 'Advanced QR Code Generator',
  siteName: 'QRaft Code',
  organization: 'QRaft Code',

  // URLs
  siteUrl: 'https://qraftcode.com',

  // Defaults
  defaultTitle: 'QRaft Code - Advanced QR Code Generator',
  defaultImage: '/images/og-image.jpg',
  defaultImageAlt: 'QRaft Code - Advanced QR Code Generator',

  // Navigation
  navItems: [
    { label: 'Home', href: '#home' },
    { label: 'How It Works', href: '#how' },
    { label: 'Features', href: '#features' },
    { label: 'Pricing', href: '#pricing' },
    { label: 'Try It Out', href: '/qr' },
  ],

  // Developer information
  developer: {
    name: 'Transpiled, LLC',
    url: 'https://transpiled.com/',
  },

  // Localization
  locale: 'en_US',

  // Default content type
  type: 'website',
};

// Default SEO values
export const seoDefaults = {
  title: 'Qraft Code - Advanced QR Code Generator',
  description:
    'Qraft Code is an advanced QR code generator that allows you to create professional QR codes for your website, business, or personal use.',
  businessName: 'Transpiled, LLC',
  businessType: 'LLC',
  foundingDate: '2025-06-29',
  canonical: 'https://qraftcode.com',
  ogImageURL: '/images/og-image.jpg',
  imageAlt: 'Qraft Code - Custom QR Code Generator',
  type: 'website',
  locale: 'en_US',
  keywords:
    'qr code generator, custom qr code generator, qr code, qr code generator app, qr code generator website, qr code generator tool',
  twitterCardType: 'summary_large_image',
};
